import { LensTag } from '@/types/Product';

/**
 * Características da lente, marcadas por cor no backoffice. A letra, o
 * nome e a explicação ficam aqui (não no backend) para se poderem afinar
 * os textos sem mexer na API. O `label` é também o valor do filtro
 * "Lentes" no URL das categorias (?lentes=Polarizado) — tem de bater com
 * LENS_TAG_LABELS no backend.
 */
export const LENS_TAGS: Record<
  LensTag,
  { letter: string; label: string; description: string }
> = {
  POLARIZED: {
    letter: 'P',
    label: 'Polarizado',
    description:
      'Lentes polarizadas: eliminam o brilho, aumentam a nitidez e melhoram o contraste.',
  },
  PHOTOCHROMIC: {
    letter: 'F',
    label: 'Fotocromático',
    description:
      'Lentes fotocromáticas: escurecem automaticamente com a luz do sol e voltam a clarear em interiores.',
  },
  MIRRORED: {
    letter: 'E',
    label: 'Espelhado',
    description:
      'Lentes espelhadas: o revestimento exterior reflete parte da luz, reduzindo o encandeamento.',
  },
};

// Ordem fixa de apresentação, independente da ordem em que foram marcadas.
export const LENS_TAG_ORDER: LensTag[] = ['POLARIZED', 'PHOTOCHROMIC', 'MIRRORED'];
